export default __webpack_public_path__ + "static/RootSans-4LightItalic-1066afb27b7b89c8975b27dda61dbf9f.woff2";